import { epicRequest, serverResponse } from 'app'

export const TOURNAMENT_LIST_FETCH = 'TOURNAMENT_LIST_FETCH'
export const TOURNAMENT_LIST_FETCH_ERROR = 'TOURNAMENT_LIST_FETCH_ERROR'
export const TOURNAMENT_LIST_FETCH_FULFILLED = 'TOURNAMENT_LIST_FETCH_FULFILLED'
export const TOURNAMENT_LIST_FETCH_CANCELED = 'TOURNAMENT_LIST_FETCH_CANCELED'

export const getInitialState = () => serverResponse()

export const tournamentListFetch = (id, page, type = 'user') => ({
  payload: {
    id,
    page,
    type,
  },
  type: TOURNAMENT_LIST_FETCH,
})

export const tournamentListFetchFulfilled = (payload) => ({
  payload,
  type: TOURNAMENT_LIST_FETCH_FULFILLED,
})

export const tournamentListFetchCanceled = () => ({
  payload: null,
  type: TOURNAMENT_LIST_FETCH_CANCELED,
})

export const tournamentListFetchError = (payload) => ({
  payload,
  type: TOURNAMENT_LIST_FETCH_ERROR,
})

export const tournamentListFetchEpic = epicRequest({
  actionType: TOURNAMENT_LIST_FETCH,
  errorAction: tournamentListFetchError,
  fulfilledAction: tournamentListFetchFulfilled,
  request: ({ payload }) => {
    const page = payload.page > 1 ? `?page=${payload.page}&` : '?'
    const id = payload.id ? `${payload.id}/` : ''
    return `${payload.type}/${id}tournaments${page}per_page=100`
  },
  untilTypes: TOURNAMENT_LIST_FETCH_CANCELED,
})
